'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');
const membershipCancelAccountFactory = require('components/membership/membership_cancel_account/js/main');
const userCancelAccountFactory = require('components/user_area/cancel_account/js/main');
const {isMembershipStatusActivated} = require('od-modules/utils/membership_utils');

const MY_AREA_CATEGORY = 'my_area_account';
const SSO_CATEGORY = 'sso_module';

const membershipWidgetsConfig = [
    {
        id: 'membership-account-preferences',
        factory: require('../../../membership/membership_account_preferences/js/main'),
    },
];

let PRCComponent = null;

const isMembershipPriceDisplay = (membershipDTO) => isMembershipStatusActivated(membershipDTO) && !Odigeo.Utils.isRequestApp('dp');

const preventDefaultAndPropagation = (cb) => {
    return function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        cb.call(this);
    };
};

const getError = function() {
    const errorPsw = this.model.get('errorPsw');
    const errors = this.model.get('errors');
    return !Odigeo._.isUndefined(errors[errorPsw]) ? errors[errorPsw] : errors['default'];
};

const refreshKeys = function(userDTO) {
    const membershipDTO = Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO', null);
    if (membershipDTO) {
        this.$el.find(this.selectors.cancelAccContainer).addClass('odf-hidden');
        PRCComponent && PRCComponent.destroy();
    }
};

const createAccountPreferenceSubViews = function(userDTO) {
    const membershipDTO = Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO');
    const membershipPriceDisplayEnabled = isMembershipPriceDisplay(membershipDTO);
    const {keys, $el, selectors, templates} = this;
    const defaultTemplateData = {
        membershipPriceDisplayEnabled,
        keys,
    };

    $el.find(selectors.accountTitle).html(templates.accountTitle(defaultTemplateData));

    if (membershipPriceDisplayEnabled) {
        Odigeo._.each(membershipWidgetsConfig, ({factory, id}) =>
            factory.create({
                id: id,
                options: {
                    membershipDTO: membershipDTO,
                },
            })
        );
    }
};

const resetPasswordViewerIcons = ($pwdIconWrapper) => {
    $pwdIconWrapper.find('.show_password_chars').removeClass('odf-hidden');
    $pwdIconWrapper.find('.hide_password_chars').addClass('odf-hidden');
};

const clearPasswordField = ($pwdFieldWrapper, $pwdIconWrapper) => {
    $pwdFieldWrapper
        .removeClass('valid invalid invalid-long')
        .find('input')
        .val('')
        .attr('type', 'password');
    $pwdIconWrapper
        .addClass('hidden');
    resetPasswordViewerIcons($pwdIconWrapper);
};

module.exports = withRenderedMain(
    withCachedSelectors(
        BaseView.extend({
            events: {
                'tap .old_password_icon': 'onTapOldPasswordIcon',
                'tap .new_password_icon': 'onTapNewPasswordIcon',
                'input .account_pref_old_pass': 'onInputAccountPrefOldPass',
                'input .account_pref_new_pass': 'onInputAccountPrefNewPass',
                'tap .account_pref_change_passBtn': 'onTapAccountPrefChangePassBtn',
                'tap .account_pref_change_pass_link': 'onTapChangePassLink',
                'tap .change_pass_close': 'onTapChangePassClose',
                'tap .account_pref_cancel_account_link': 'onTapCancelAccountLink',
            },

            selectors: {
                accountPrefBody: '.account_pref_body',
                accountPrefEmail: '.account_pref_email',
                accountPrefPassword: '.account_pref_password',
                accountPrefOldPass: '.account_pref_old_pass',
                accountPrefNewPass: '.account_pref_new_pass',
                accountPrefOldPassWrapper: '.account_pref_old_pass_wrapper',
                accountPrefNewPassWrapper: '.account_pref_new_pass_wrapper',
                accountPrefNotification: '.account_pref_notification_changed',
                accountPrefError: '.account_pref_notification_error',
                accountPrefErrorTxt: '.account_pref_notification_error_txt',
                accountTitle: '.account_title',
                accountCancelAccountLink: '.account_pref_cancel_account_link',
                accountPrefClearInput: '.clear_input',
                allFocused: 'input:not([type="hidden"]), select',
                cancelHint: '.account_pref_cancel_account',
                changePassView: '.change_pass_container',
                newPasswordIcon: '.new_password_icon',
                oldPasswordIcon: '.old_password_icon',
                cancelAccContainer: '.cancel_acc_container',
            },

            initialize: function() {
                this.listenTo(this.model, 'change:userDTO', this.onModelUpdate);
                const instantTransitionsOptions = {
                    fadeInTimes: {
                        duration: 0,
                        delay: 0,
                    },
                    fadeOutTimes: {
                        duration: 0,
                        delay: 3,
                    },
                };
                Odigeo.UIElements.fade.enhance(this.$cachedSelectors.accountPrefNotification, instantTransitionsOptions);
                Odigeo.UIElements.fade.enhance(this.$cachedSelectors.accountPrefError, instantTransitionsOptions);
            },

            onModelUpdate(model) {
                createAccountPreferenceSubViews.call(this, model.get('userDTO'));
                refreshKeys.call(this, model.get('userDTO'));
            },

            onRefreshKeys(model) {
                refreshKeys.call(this, model.get('userDTO'));
            },

            onCheckDefaultBillingVisibility() {
                PRCComponent && PRCComponent.execute('checkDefaultBillingVisibility');
            },

            onTapOldPasswordIcon() {
                this._changeCharsViewer('oldPasswordIcon', this.$cachedSelectors.accountPrefOldPass);
            },

            onTapNewPasswordIcon() {
                this._changeCharsViewer('newPasswordIcon', this.$cachedSelectors.accountPrefNewPass);
            },

            onInputAccountPrefOldPass() {
                this.$cachedSelectors.oldPasswordIcon.removeClass('hidden');
            },

            onInputAccountPrefNewPass() {
                this.$cachedSelectors.newPasswordIcon.removeClass('hidden');
            },

            onTapAccountPrefChangePassBtn: preventDefaultAndPropagation(function() {
                this.changePassword();
            }),

            onTapChangePassLink() {
                trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'change_password');
                this.clearPasswordFields();
                this.$cachedSelectors.changePassView.addClass('open opened');
            },

            onTapChangePassClose() {
                this.clearPasswordFields();
                this.$cachedSelectors.changePassView.removeClass('open opened');
            },

            onTapCancelAccountLink() {
                const hasMembershipForBrand = this.model.get('hasMembershipForBrand');
                const showCancelAccountDialog = typeof hasMembershipForBrand === 'boolean';
                const cancelAccountFactory = hasMembershipForBrand ? membershipCancelAccountFactory : userCancelAccountFactory;

                showCancelAccountDialog && cancelAccountFactory.create({id: 'cancel-account'}).execute('open');
            },

            hideHint() {
                this.$cachedSelectors.changePassView.removeClass('open opened');
            },

            showDetails() {
                this.$cachedSelectors.allFocused.on(Odigeo.Events.focus, Odigeo._.bind(this.focusHandler, this));
                this.$cachedSelectors.allFocused.on(Odigeo.Events.blur, Odigeo._.bind(this.blurHandler, this));

                if (!Odigeo._.isEmpty(this.$cachedSelectors.cancelHint)) {
                    this.hideHint();
                }

                this.$cachedSelectors.accountPrefNotification.addClass('hidden');
                this.$cachedSelectors.accountPrefError.addClass('hidden');
                if (this.model.get('passwordChanged')) {
                    this.$cachedSelectors.accountPrefNotification.trigger('fadeElement');
                }

                this.$cachedSelectors.accountPrefEmail.empty().append(this.model.get('userDTO').email);
                this.$cachedSelectors.accountPrefPassword.toggleClass('odf-hidden', !this.model.get('isActive'));
                this.$cachedSelectors.accountPrefBody.removeClass('hidden');

                if (!Odigeo._.isEmpty(this.model.get('errorPsw'))) {
                    const error = getError.call(this);

                    if (error === 'loginerror') {
                        this.$cachedSelectors.accountPrefOldPassWrapper
                            .removeClass('valid')
                            .addClass('invalid')
                            .find('.error_message')
                            .text(this.$cachedSelectors.accountPrefOldPass.data(error));
                    } else {
                        this.$cachedSelectors.accountPrefErrorTxt.text(this.$cachedSelectors.accountPrefError.data(error)).trigger('fadeElement');
                        this.$cachedSelectors.accountPrefError.trigger('fadeElement');
                    }
                    this.$cachedSelectors.changePassView.addClass('open opened');
                }

                if (!Odigeo._.isEmpty(this.model.get('error'))) {
                    this.$cachedSelectors.accountPrefError.trigger('fadeElement');
                }

                this.$cachedSelectors.accountPrefClearInput.off().on(Odigeo.Events.tap, function(evt) {
                    const $wrapper = $(evt.currentTarget).closest('.input_wrapper');
                    const $input = $wrapper.find('input');
                    $input.val('');
                    $wrapper.addClass('invalid').removeClass('valid');
                    $input.focus();
                });

                this.model.set('passwordChanged', false);
            },

            focusHandler(evt) {
                const $el = $(evt.target);
                $el.closest('.input_wrapper')
                    .addClass('focused')
                    .removeClass('valid empty');
            },

            blurHandler(evt) {
                const $el = $(evt.target);
                const $wrapper = $el.closest('.input_wrapper');
                const isPasswordOk = this.checkPasswordValidity($el);
                $wrapper
                    .removeClass('focused')
                    .toggleClass('valid', isPasswordOk)
                    .toggleClass('invalid', !isPasswordOk);
                if (!isPasswordOk) {
                    $wrapper.find('.error_message').text(this.$cachedSelectors.accountPrefError.data('incorrectformat'));
                }
            },

            _changeCharsViewer(selectorName, $pwdField) {
                const $pwdCharViewer = this.$cachedSelectors[selectorName].find('.password_char_viewer, .show_password_chars, .hide_password_chars');
                $pwdCharViewer.toggleClass('odf-hidden');
                $pwdField.attr('type', $pwdField.attr('type') === 'password' ? 'text' : 'password');
            },

            changePassword() {
                const $oldPassword = this.$cachedSelectors.accountPrefOldPass;
                const $newPassword = this.$cachedSelectors.accountPrefNewPass;
                const data = {
                    oldPassword: $oldPassword.val(),
                    newPassword: $newPassword.val(),
                };
                const errText = this.$cachedSelectors.accountPrefError.data('incorrectformat');
                const isLongError = errText.length > this.errorMaxLength;

                if (this.checkPasswordValidity($oldPassword) && this.checkPasswordValidity($newPassword)) {
                    this.$cachedSelectors.accountPrefOldPassWrapper.removeClass('invalid-long');
                    this.$cachedSelectors.accountPrefNewPassWrapper.removeClass('invalid-long');
                    trackingUtils.trackEventWithCategory(SSO_CATEGORY, 'change_password', 'change_password');
                    Odigeo.trigger(this.id + ':submitUserRequest', {action: 'changePassword', data});
                } else {
                    this.checkErrors($oldPassword, this.$cachedSelectors.accountPrefOldPassWrapper, isLongError, errText);
                    this.checkErrors($newPassword, this.$cachedSelectors.accountPrefNewPassWrapper, isLongError, errText);
                }
            },

            checkPasswordValidity($input) {
                return !Odigeo._.isEmpty($input.val()) && Odigeo.Utils.isValidPassword($input.val(), true);
            },

            checkErrors($input, $wrapper, isLongError, errText) {
                if (!this.checkPasswordValidity($input)) {
                    $wrapper
                        .addClass(isLongError ? 'invalid-long' : 'invalid')
                        .find(isLongError ? '.error_long_message' : '.error_message')
                        .text(errText);
                }
            },

            clearPasswordFields() {
                clearPasswordField(this.$cachedSelectors.accountPrefOldPassWrapper, this.$cachedSelectors.oldPasswordIcon);
                clearPasswordField(this.$cachedSelectors.accountPrefNewPassWrapper, this.$cachedSelectors.newPasswordIcon);
            },
        })
    )
);
